var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteItemImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19.5,
    viewBox: "0 0 18 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_40_25",
    "data-name": "Componente 40 \\u2013 25",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_806",
    "data-name": "Trazado 806",
    d: "M1298.25,397.25h-16.5",
    transform: "translate(-1281.75 -394.25)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_807",
    "data-name": "Trazado 807",
    d: "M1287.75,401.75v6",
    transform: "translate(-1281.75 -394.25)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_808",
    "data-name": "Trazado 808",
    d: "M1292.25,401.75v6",
    transform: "translate(-1281.75 -394.25)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_809",
    "data-name": "Trazado 809",
    d: "M1296.75,397.25V411.5a.751.751,0,0,1-.75.75h-12a.751.751,0,0,1-.75-.75V397.25",
    transform: "translate(-1281.75 -394.25)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_810",
    "data-name": "Trazado 810",
    d: "M1293.75,397.25v-1.5a1.5,1.5,0,0,0-1.5-1.5h-4.5a1.5,1.5,0,0,0-1.5,1.5v1.5",
    transform: "translate(-1281.75 -394.25)",
    fill: "none",
    stroke: "#818181",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteItemImg);
export default __webpack_public_path__ + "static/media/DeleteItemImg.1a9a4aeabab9227579c8945804bac7a3.svg";
export { ForwardRef as ReactComponent };